/* this file is transformed by vux-loader */
/* eslint-disable */
export var authLogin = '/api/auth/login';
export var authRegister = '/api/auth/register';
export var fetchUserInfo = '/api/user/info';
export var fetchUserContact = '/api/user/contact';